<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Warehouse was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Warehouse - {{ this.warehouse.name }}</h1>
    <app-audit-line [data]='this.warehouse'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-warehouse-form [warehouse]='this.warehouse'></app-warehouse-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/warehousing/warehouses'>Cancel</button>
    </form>
  </div>
</div>
